import React, { memo, useMemo } from "react";
import { theme } from "uikit";
import { useTranslation } from "react-i18next";

import Map, { type PolygonList } from "../../../../../components/DispatcherMap";
import { useTypedSelector } from "../../../../../redux/store";

const BasePriceZones: React.FC<BasePriceZones.Props> = ({
	taxiServiceId,
}): JSX.Element => {
	const { t } = useTranslation();
	const lang = useTypedSelector((state) => state.session.language);
	const priceZones = useTypedSelector(
		(state) => state.globalState.priceZones.data.subscription.basic,
	);

	const text = useMemo(
		() => t(`mainPage.archives.orders.modal.map.polygons.priceZone`),
		[t],
	);

	const value = useMemo<PolygonList | undefined>(
		() =>
			taxiServiceId
				? priceZones
						.filter((item) => item?.taxiServiceId === taxiServiceId)
						.map((priceZone) => ({
							id: priceZone.id,
							name:
								`${text} ${priceZone.name?.[lang]}` ||
								Object.values(priceZone.name)?.[0],
							color: theme.colors.success,
							vertices: priceZone.vertices.map((v) => [
								v.lat,
								v.lng,
							]),
							editable: false,
						}))
				: priceZones.map((priceZone) => ({
						id: priceZone.id,
						name:
							`${text} ${priceZone.name?.[lang]}` ||
							Object.values(priceZone.name)?.[0],
						color: theme.colors.success,
						vertices: priceZone.vertices.map((v) => [v.lat, v.lng]),
						editable: false,
				  })),
		[lang, priceZones, text, taxiServiceId],
	);

	return <Map.PolygonEditor value={value} editing={false} />;
};

declare namespace BasePriceZones {
	interface Props {
		taxiServiceId?: number;
	}
}

export const PriceZones = memo(BasePriceZones);
export default BasePriceZones;
